import { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';
import { useMasterDataContext } from '../../Context/masterDataContext';
import { saveAssetAssignedDetails } from "../../Api/AssetManagement";


const AssignAsset = () => {
  const navigate = useNavigate();
  const { fetchAssetData,
    loadAssetMaster } = useAssetContext();
  const { resourceData,
    loadResources } = useMasterDataContext();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  console.log("UserId: ", userId);


  console.log(resourceData, 'resourceData')
  console.log(fetchAssetData, 'fetchAssetData')

  const intitalValues = {
    Asset_ID: "", // Asset_ID
    Assignee_ID: "", // 
    withEffectOf: "",
    Remarks: ""
  }

  const [formValues, setFormValues] = useState(intitalValues);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveAssetAssignedDetails(formValues, userId);
      toast.success(`🦄 Added Successfully`);
      setFormValues(intitalValues);
      // navigate("/budgetMaster");
    } catch (error) {
      toast.error(`🦄 Error : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAssetMaster();
    loadResources()
  }, []);

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Assign Asset</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Id <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="Asset_ID"
                    value={formValues.Asset_ID}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Asset Id</option>
                    {fetchAssetData.map((option) => (
                      <option key={option.asset_ID} value={option.asset_ID}>
                        {option.asset_ID}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Assignee ID <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="Assignee_ID"
                    value={formValues.Assignee_ID}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Assignee</option>
                    {resourceData.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>With Effect Off</Form.Label>
                  <Form.Control
                    type="date"
                    name="withEffectOf"
                    value={formValues.withEffectOf}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="Remarks"
                    value={formValues.Remarks}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Asset"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default AssignAsset